import { formsApi } from "@api";
import { useDownloadPdf } from "../../../Invoices/utils";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";

/**
 * Downloads the stamped PDF the forms service generated at submit time.
 * 404s until a submit has produced one (generation is best-effort
 * server-side).
 *
 * The SDK types `getFormPdf` as `void` (the generator drops the binary
 * body), so the blob is read off the raw response via
 * `getFormPdfRaw().raw.blob()` — the standard escape hatch for binary
 * downloads (see useMutationDownloadPayeeW9). The forms endpoints scope by
 * the session token, so no engagement/context param is sent.
 */
export const useMutationDownloadEmployeeTaxFormPdf = () => {
  const downloadPdfFile = useDownloadPdf();

  return useWSMutation<
    void,
    WSServiceError,
    {
      formInstanceId: string;
      filename: string;
    }
  >(async ({ formInstanceId, filename }) => {
    const response = await formsApi.getFormPdfRaw({ formId: formInstanceId });
    const blob = await response.raw.blob();
    const url = window.URL.createObjectURL(blob);
    downloadPdfFile(url, filename);
  });
};
